export enum ResourceAction {
  ADD = 'add',
  DEACTIVATE = 'deactivate',
  DELETE = 'delete',
  EXPORT = 'export',
  READ = 'read',
  UPDATE = 'update'
}

export enum ProtectedResource {
  DEVICE = 'device',
  ENTERPRISE = 'enterprise',
  ENTERPRISE_USER = 'enterprise-user',
  INTEGRATION_CIBOLABS = 'integration-cibolabs',
  INTERNAL_DETAILS = 'internal-details',
  INTERNAL_USER = 'internal-user',
  INVITATION = 'invitation',
  IP_CAMERA = 'ip-camera',
  NOTIFICATION = 'notification',
  NOTIFICATION_POLICY = 'notification-policy',
  SAMPLE_POINT = 'sample-point',
  SITE = 'site',
  TRIGGER = 'trigger',
  USER_MEMBERSHIP = 'user-membership'
}